import React, { useRef } from "react";
import { useObserver } from "mobx-react";
import { useStores } from "../../../store";
import { DownloadResume } from "../resume_output";
import { useReactToPrint } from "react-to-print";


const Resume2 = () => {
    
    const {ResumeStore } = useStores();
    const resumeRef = useRef(null);

    const handleDownload = useReactToPrint({
      content: () => resumeRef.current,
    });

    return useObserver(() => (
     <>
      <DownloadResume onClick={handleDownload}/>
      <div className="flex w-full max-w-4xl mx-auto mt-10 p-6 bg-white shadow-lg" ref={resumeRef}>
        <div className="w-1/4 bg-gray-800 text-white p-4">
          <div className="mb-4">
            <img
              src={ResumeStore?.resumeBuilder?.profile || 'https://images.unsplash.com/photo-1508341591423-4347099e1f19?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8bWVufGVufDB8fDB8fHww'}
              alt="Profile"
              className="flex items-center rounded-full w-[100px] h-[100px] md:w-[180px] mx-auto md:h-[180px]"
            />
          </div>
          <h1 className="text-xl font-bold">{`${ResumeStore.resumeBuilder.personalDetails.firstName} ${ResumeStore.resumeBuilder.personalDetails.lastName}`}</h1>
          <h2 className="text-lg text-gray-400">{ResumeStore.resumeBuilder.personalDetails.jobTitle}</h2>
          <div className="mt-4">
            <p><strong>Phone:</strong> {ResumeStore.resumeBuilder.personalDetails.phone}</p>
            <p><strong>Email:</strong> {ResumeStore.resumeBuilder.personalDetails.email}</p>
            <p><strong>Address:</strong> {ResumeStore.resumeBuilder.personalDetails.address}</p>
          </div>
          <h3 className="mt-6 text-lg text-primary">Skills</h3>
          <ul>
            {ResumeStore.resumeBuilder.skills.map((skill, index) => (
              <li key={index} className="flex items-center my-1">
                <span>{skill}</span>
                {/* <div className="w-3/4 bg-gray-400 h-2 ml-2">
                  <div className="bg-blue-600 h-2" style={{ width: `${skill.level}%` }}></div>
                </div> */}
              </li>
            ))}
          </ul>
          <h3 className="mt-6 text-lg text-primary">Awards</h3>
          <ul>
            {ResumeStore.resumeBuilder.extraCurricularActivities?.map((award, index) => (
              <li key={index}>{award?.functionTitle}</li>
            ))}
          </ul>
        </div>
        <div className="w-3/4 p-4">
          <h3 className="text-lg text-primary">About Me</h3>
          <p>{ResumeStore.resumeBuilder.profileSummary}</p>
          <h3 className="mt-6 text-lg text-primary">Education and Qualifications</h3>
          {ResumeStore.resumeBuilder.education.map((edu, index) => (
            <div key={index} className="mb-4">
              <p><strong>{edu.startDate} - {edu.endDate}:</strong> {edu.degree} at {edu.school}</p>
              <p>{edu.description}</p>
            </div>
          ))}
          <h3 className="mt-6 text-lg text-primary">Work Experience</h3>
          {ResumeStore.resumeBuilder.employementHistory.map((job, index) => (
            <div key={index} className="mb-4">
              <p><strong>{job.startDate} - {job.endDate}:</strong> {job.jobTitle} at {job.company}</p>
              <p>{job.description}</p>
            </div>
          ))}
        </div>
      </div>
     </>
    ));
  };

  export default Resume2;